import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m24.943 19.057-8-8a1.332 1.332 0 0 0-1.885 0l-8 8a1.332 1.332 0 1 0 1.885 1.885L16 13.885l7.057 7.057a1.332 1.332 0 1 0 1.885-1.885h.001Z" }));
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
